export default __webpack_public_path__ + "static/media/hi.b027c2d6.png";